import react, { useContext } from 'react';

import { Locations } from '../../services/types/contractListRequest';
import { FilterOption } from '../contractList/filters/filterDialog/filterDialog';

export interface FilterContext {
  locations: Locations;
  divisions: string[];
  countries: FilterOption[];
  shipToParties: string[];
  contractType: string;
  contractUsage: string;
  contractStatus: string;
  contractNumber: string;
  serialNumber: string;
  activeContracts: boolean;
  finishedContracts: boolean;
  customerReference: string;
  beginDateStart: Date | null;
  beginDateEnd: Date | null;
  upToRows: number;
  offset: number;
  setLocations: (locations: Locations) => void;
  setDivisions: (division: string[]) => void;
  setCountries: (country: FilterOption[]) => void;
  setShipToParties: (shipToParty: string[]) => void;
  setContractType: (contractType: string) => void;
  setContractUsage: (contractUsage: string) => void;
  setContractStatus: (contractStatus: string) => void;
  setContractNumber: (contractNumber: string) => void;
  setSerialNumber: (serialNumber: string) => void;
  setActiveContracts: (activeContracts: boolean) => void;
  setFinishedContracts: (finishedContracts: boolean) => void;
  setCustomerReference: (customerReference: string) => void;
  setBeginDateStart: (beginDateStart: Date | null) => void;
  setBeginDateEnd: (beginDateEnd: Date | null) => void;
  setUpToRows: (upToRows: number) => void;
  setOffset: (offset: number) => void;
}

export const initialFilterContext = {
  locations: { soldToParties: [] },
  divisions: [''],
  countries: [],
  shipToParties: [''],
  contractType: '',
  contractUsage: '',
  contractStatus: '',
  contractNumber: '',
  serialNumber: '',
  activeContracts: true,
  finishedContracts: false,
  customerReference: '',
  beginDateStart: null,
  beginDateEnd: null,
  upToRows: 10,
  offset: 0,
  setDivisions: () => {},
  setCountries: () => {},
  setShipToParties: () => {},
  setContractType: () => {},
  setContractUsage: () => {},
  setContractStatus: () => {},
  setContractNumber: () => {},
  setSerialNumber: () => {},
  setActiveContracts: () => {},
  setFinishedContracts: () => {},
  setCustomerReference: () => {},
  setBeginDateStart: () => {},
  setBeginDateEnd: () => {},
  setLocations: () => {},
  setUpToRows: () => {},
  setOffset: () => {},
};

export const filterContext =
  react.createContext<FilterContext>(initialFilterContext);

export const useFilterContext = () => useContext(filterContext);
